import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mysolvrEntryCardComponent from 'mysolvr-entry-card';
import mysolvrEntryListComponent from './mysolvr-entry-list.component';

let mysolvrEntryListModule = angular.module('mysolvrEntryList', [
  uiRouter,
])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $stateProvider
      .state('engineer.mysolvr-entries.mysolvr-entry-list', {
        url: '/:filter',
        template: '<mysolvr-entry-list class="mysolvr-entry-list"></mysolvr-entry-list>'
      });
  })
  .component('mysolvrEntryCard', mysolvrEntryCardComponent)
  .component('mysolvrEntryList', mysolvrEntryListComponent);

export default mysolvrEntryListModule;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/screens/mysolvr-entry-list/index.js